import { Box, Grid, Skeleton, useTheme } from "@mui/material";

function GroupHeadingSkeleton(): JSX.Element {
    const theme = useTheme()

    return (
        <Box
            sx={{
                padding: { xs: "15px 15px 3px 15px", md: "20px 20px 5px 20px" },
                display: "flex",
                alignItems: "center"
            }}
        >
            <Skeleton width={100} sx={{ ...theme.typography.body_500 }} />
        </Box>
    );
}

function CardSkeleton(): JSX.Element {
    const theme = useTheme();

    return (
        <Grid
            container
            rowSpacing={1}
            sx={{
                padding: { xs: "15px", md: "25px" },
                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`
            }}
        >
            <Grid item xs={12} md={9}>
                <Box sx={{ display: "flex", columnGap: "10px" }}>
                    <Skeleton
                        variant="circular"
                        width={30}
                        height={30}
                        sx={{ flexShrink: 0 }}
                    />
                    <Box
                        sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            rowGap: "10px"
                        }}
                    >
                        <Skeleton width="45%" sx={{ ...theme.typography.body_600 }} />
                        <Box sx={{ display: "flex", columnGap: 1 }}>
                            <Skeleton variant="rectangular" width={70} height={22} sx={{ borderRadius: "4px" }} />
                            <Skeleton variant="rectangular" width={180} height={22} sx={{ borderRadius: "4px" }} />
                            <Skeleton variant="rectangular" width={80} height={22} sx={{ borderRadius: "4px" }} />
                        </Box>
                        <Skeleton width="95%" />
                        <Skeleton
                            width="30%"
                            sx={{ display: { xs: "block", md: "none" } }}
                        />
                    </Box>
                </Box>
            </Grid>
            <Grid item xs={12} md={3} sx={{ display: { xs: "none", md: "block" } }}>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        height: "100%"
                    }}
                >
                    <Skeleton width="60%" />
                </Box>
            </Grid>
        </Grid>
    );
}

export default function SkeletonLoading(): JSX.Element {
    return (
        <Box sx={{ height: "100%", overflowY: "auto" }}>
            <GroupHeadingSkeleton />
            {[1, 2].map((item) => (
                <CardSkeleton key={`group1-${item}`} />
            ))}
            <GroupHeadingSkeleton />
            {[1, 2].map((item) => (
                <CardSkeleton key={`group2-${item}`} />
            ))}
        </Box>
    );
}